export enum CohortStatuses {
  LAUNCH = 'launch',
  IN_PREPARATION = 'in_preparation',
  IN_PROGRESS = 'in_progress',
  COMPLETE = 'complete',
}
